import type { useTranslations } from "contexts/LocalizationContext";

export const localizeAirportName = (
  airportCode: string,
  originalName: string,
  translations: ReturnType<typeof useTranslations>
) => {
  const translationKey = `airport_${airportCode.toLowerCase()}`;
  const airportName = translations(translationKey);
  return airportName === translationKey ? originalName : airportName;
};

export const localizeAirportLocation = (
  airportCode: string,
  airportCountryCode: string,
  airportCity: string,
  airportCountry: string,
  translations: ReturnType<typeof useTranslations>
) => {
  const cityTranslationKey = `city_${airportCode.toLowerCase()}`;
  const countryTranslationKey = `country_${airportCountryCode.toLowerCase()}`;

  const cityTranslation = translations(cityTranslationKey);
  const countryTranslation = translations(countryTranslationKey);

  const city = cityTranslation === cityTranslationKey ? airportCity : cityTranslation;
  const country = countryTranslation === countryTranslationKey ? airportCountry : countryTranslation;

  return `${city}, ${country}`;
};
